/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0623/9653/0827/files/202512102-p1.png',
    'https://cdn.shopify.com/s/files/1/0623/9653/0827/files/202512102-p2.png',
    'https://cdn.shopify.com/s/files/1/0623/9653/0827/files/202512102-p3.png',
    'https://cdn.shopify.com/s/files/1/0623/9653/0827/files/202512102-p4.png',
    'https://cdn.shopify.com/s/files/1/0623/9653/0827/files/202512102-p5.png',
    'https://cdn.shopify.com/s/files/1/0623/9653/0827/files/202512102-p6.png',
  ]

  new Swiper('.sp-swiper-fade-top', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  // new Swiper(".sp-btn-style1 .swiper", {
  //   spaceBetween: 10,

  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },
  //   loop: true,
  // });

  let _spswiper2 = new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    on: {
      slideChange: function (e) {
        $('#sp_btns .sp-p')
          .eq(e.realIndex)
          .addClass('sp-active')
          .siblings()
          .removeClass('sp-active')
      },
    },
  })
  // 点击切换轮播
  $('#sp_btns .sp-p').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
    _spswiper2.slideToLoop($(this).index())
  })

  let _spswiper2m = new Swiper('.sp-swiper2-m', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.sp-swiper-btn-next-m',
      prevEl: '.sp-swiper-btn-prev-m',
    },
    pagination: {
      el: '.sp-pagination-m',
      clickable: true,
    },
    on: {
      slideChange: function (e) {
        $('#sp_btnsm .sp-p')
          .eq(e.realIndex)
          .addClass('sp-active')
          .siblings()
          .removeClass('sp-active')
      },
    },
  })

  // 点击切换轮播
  $('#sp_btnsm .sp-p').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
    _spswiper2m.slideToLoop($(this).index())
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 50,
  })

  $(' .sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    changePrice()

    let numOptions = $(' #sp-num .sp-option.active').index()
    let colorOptions = $(' #sp-type .sp-option.active').index()

    // _index = numOptions + colorOptions *2;
    _index = colorOptions;

    // $(".sp_product_part.sp_mobile .sp-img-p")
    //   .eq(_index)
    //   .addClass("active")
    //   .siblings()
    //   .removeClass("active");

    _swiper.slideToLoop(_index)

    // 更新DIY盒子的乘数显示
    updateDiyBoxMultiplier(colorOptions)
  })

  // DIY盒子乘数显示函数
  function updateDiyBoxMultiplier(optionIndex) {
    var $diyMulti = $('.sp-diy-box .sp-diy-multi')
    if (optionIndex === 0) {
      // 选项1: Buy 1 - 不显示乘数
      $('.sp-diy-box').show()
      $diyMulti.text('').show()
    } else if (optionIndex === 1) {
      $('.sp-diy-box').show()
      // 选项2: Buy 2 Get 1 Free (3 PCS) - 显示X3
      $diyMulti.text('X3').show()
    } else if (optionIndex === 2) {
      $('.sp-diy-box').show()
      // 选项3: Buy 3 Get 2 Free (5 PCS) - 显示X5
      $diyMulti.text('X5').show()
    } else if (optionIndex === 3) {
      $('.sp-diy-box').show()
      $diyMulti.text('X10').show()
    } else if (optionIndex === 4) {
      // 选项3: Buy 3 Get 2 Free (5 PCS) - 显示X5
      //   $diyMulti.text("X8").show();
      $('.sp-diy-box').hide()
    }
  }

  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
        // 底部粘性栏也需要缩放
        $('.sp-bottom-bar-link').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
                $('.sp-bottom-bar-link').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop

        let sptop = document.body.clientWidth <= 1080 ? 0 : 65

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let prods = window.product
  function getCur() {
    let num = $('#sp-num div.active').attr('data-val')
    let type = $('#sp-type div.active').attr('data-val')
    return prods.filter(item => item.option1 == num && item.option2 == type)[0]
    // return prods.filter(item => item.option1 == num)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.font-off').html(off_font)
    console.log(off_font)
  }
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      changePrice()
    }
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动固定顶部导航
  $(window).scroll(function () {
    if ($(window).scrollTop() > 100) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 移动端底部粘性栏：滚动超过首屏后显示，回到首屏时隐藏
    if (document.body.clientWidth <= 1080) {
      var screenHeight = window.innerHeight
      if ($(window).scrollTop() > screenHeight * 0.5) {
        $('.sp-btn-style2.sp-fixed-bottom').addClass('sp-show')
      } else {
        $('.sp-btn-style2.sp-fixed-bottom').removeClass('sp-show')
      }
    }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  $(document).on('click', '.sp_add_cart', function () {
    // 购物车加购动效

    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)
    $(' .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-cart').removeClass('on')
    }, 500)

    // $("#calcNumber").val(1);

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
          })
        })
      },
      dataType: 'json',
    })

    $('.cardNum').removeClass('sp-gray')
    // handleAddToCart(initNum);

    var imgs = $('.sp_product_part .swiper-slide-active').find('img')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.sp_product_part').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',

        top: $img[0].offsetTop,
        left: $img.offset().left,
        'z-index': 99,
      })
      let finish
    //   if (document.body.clientWidth <= 1080) {
    //     finish = $('.sp-btn-style2.sp-fixed-bottom .sp-cart')
    //     var fixedBtn = $('.sp-btn-style2.sp-fixed-bottom')[0]
    //     var cartRect = finish[0].getBoundingClientRect()

    //     $(flyer).animate(
    //       {
    //         top: cartRect.top + cartRect.height / 2,
    //         left: cartRect.left + cartRect.width / 2,
    //         width: 50,
    //         height: 50,
    //         opacity: 0.4,
    //       },
    //       500,
    //       'linear',
    //       function () {
    //         $(this).animate(
    //           {
    //             width: 0,
    //             height: 0,
    //             opacity: 0,
    //           },
    //           0,
    //           function () {
    //             $(this).detach()
    //           }
    //         )
    //       }
    //     )
    //   } else {
    //     finish = $('.sp_pc .sp-cart')
    //     $(flyer).animate(
    //       {
    //         top: finish[0].offsetTop,
    //         left: finish[0].offsetLeft + finish.width() / 2,
    //         width: 50,
    //         height: 50,
    //         opacity: 0.4,
    //       },
    //       500,
    //       'linear',
    //       function () {
    //         $(this).animate(
    //           {
    //             width: 0,
    //             height: 0,
    //             opacity: 0,
    //           },
    //           0,
    //           function () {
    //             $(this).detach()
    //           }
    //         )
    //       }
    //     )
        
    //   }
    if (document.body.clientWidth <= 1080) {
        finish = $('.sp-btn-style2.sp-fixed-bottom .sp-cart')

        $(flyer).animate(
          {
            top: $('.sp-btn-style2')[0].offsetTop,
            left:
              $('.sp-btn-style2  .sp-cart')[0].offsetLeft +
              finish.width() / 2 -
              100,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      } else {
        finish = $('.sp_pc .sp_header-content .sp-flex-x .sp-cart')
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2 + 300,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      }
    })
  })

  // 问答 QA1
  $('.sp-qa1-faq-question').on('click', function () {
    var $currentItem = $(this).parent('.sp-qa1-faq-item')
    var $answer = $(this).next('.sp-qa1-faq-answer')
    var $icon = $(this).find('.sp-qa1-faq-icon')

    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
      $icon.text('+')
    } else {
      $('.sp-qa1-faq-item').removeClass('active')
      $('.sp-qa1-faq-answer').slideUp(300)
      $('.sp-qa1-faq-icon').text('+')

      $currentItem.addClass('active')
      $answer.slideDown(300)
      $icon.text('−')
    }
  })

  // 移动端 Tired of Slow 轮播图无缝滚动
  ;(function initTiredCarousel() {
    var $carousel = $('.sp-tired-carousel')
    if ($carousel.length === 0) return

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone()
    $carousel.append($items)

    // 支持触摸滑动
    var startX = 0
    var scrollLeft = 0
    var isDragging = false

    $carousel.on('touchstart mousedown', function (e) {
      isDragging = true
      $carousel.css('animation-play-state', 'paused')
      startX =
        e.type === 'touchstart' ? e.originalEvent.touches[0].pageX : e.pageX
      scrollLeft = $carousel.parent().scrollLeft()
    })

    $carousel.on('touchmove mousemove', function (e) {
      if (!isDragging) return
      e.preventDefault()
      var x =
        e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX
      var walk = (startX - x) * 2
      $carousel.parent().scrollLeft(scrollLeft + walk)
    })

    $carousel.on('touchend mouseup mouseleave', function () {
      isDragging = false
      $carousel.css('animation-play-state', 'running')
    })
  })()

  // 移动端 sp-part3 菜品轮播无缝滚动（从下往上）
  ;(function initFoodCarousel() {
    var $carousel = $('.sp-part3-food-carousel')
    if ($carousel.length === 0) return

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone()
    $carousel.append($items)
  })()

  // 移动端 sp-part3 特性轮播无缝滚动（从右往左）
  ;(function initFeaturesCarousel() {
    var $carousel = $('.sp-part3-features-carousel')
    if ($carousel.length === 0) return

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone()
    $carousel.append($items)
  })()

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani, .sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }

  // 移动端净化板块轮播图
  ;(function initPurifyCarousel() {
    const carouselInner = document.querySelector('.sp-purify-carousel-inner')
    const indicators = document.querySelectorAll('.sp-purify-indicator')
    const items = document.querySelectorAll('.sp-purify-carousel-item')

    if (!carouselInner || indicators.length === 0) return

    let currentIndex = 0
    const totalItems = items.length
    let autoPlayTimer

    function goToSlide(index) {
      currentIndex = index
      carouselInner.style.transform = `translateX(-${index * 50}%)`

      indicators.forEach((indicator, i) => {
        indicator.classList.toggle('active', i === index)
      })
    }

    function nextSlide() {
      const next = (currentIndex + 1) % totalItems
      goToSlide(next)
    }

    function startAutoPlay() {
      autoPlayTimer = setInterval(nextSlide, 4000)
    }

    function stopAutoPlay() {
      clearInterval(autoPlayTimer)
    }

    // 点击指示器切换
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => {
        stopAutoPlay()
        goToSlide(index)
        startAutoPlay()
      })
    })

    // 触摸滑动支持
    let startX = 0
    let isDragging = false

    carouselInner.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX
      isDragging = true
      stopAutoPlay()
    })

    carouselInner.addEventListener('touchend', e => {
      if (!isDragging) return
      const endX = e.changedTouches[0].clientX
      const diff = startX - endX

      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < totalItems - 1) {
          goToSlide(currentIndex + 1)
        } else if (diff < 0 && currentIndex > 0) {
          goToSlide(currentIndex - 1)
        }
      }
      isDragging = false
      startAutoPlay()
    })

    // 启动自动播放
    startAutoPlay()
  })()
})
